import React from "react";

const HowItWorksSEO = () => {
  return (
    <>
      <title>
        Hur det Fungerar - BILENIA | Komplett Guide för Bil Köp & Försäljning
      </title>
      <meta
        name="description"
        content="Upptäck hur BILENIA fungerar! Komplett guide för att köpa och sälja bilar genom vårt digitala auktionssystem. Från värdering till leverans - allt du behöver veta."
      />
      <meta
        name="keywords"
        content="BILENIA guide, bil auktion, sälja bil, köpa bil, bilhandel online"
      />
    </>
  );
};

export default HowItWorksSEO;
